/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Scope_Output5Inputs */

const en_svc_ai_integration_scope_output5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use-case map`)
};

const ar_svc_ai_integration_scope_output5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خريطة حالات الاستخدام`)
};

const bn_svc_ai_integration_scope_output5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইউজ-কেস ম্যাপ`)
};

const de_svc_ai_integration_scope_output5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwendungsfallkarte`)
};

const es_svc_ai_integration_scope_output5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa de casos de uso`)
};

const fr_svc_ai_integration_scope_output5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte des cas d'utilisation`)
};

const pt_svc_ai_integration_scope_output5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa de casos de uso`)
};

const zh_svc_ai_integration_scope_output5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用例图`)
};

const tr_svc_ai_integration_scope_output5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanım senaryosu haritası`)
};

const ru_svc_ai_integration_scope_output5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карта вариантов использования`)
};

const pl_svc_ai_integration_scope_output5 = /** @type {(inputs: Svc_Ai_Integration_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa przypadków użycia`)
};

/**
* | output |
* | --- |
* | "Use-case map" |
*
* @param {Svc_Ai_Integration_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_scope_output5 = /** @type {((inputs?: Svc_Ai_Integration_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_scope_output5(inputs)
	if (locale === "bn") return bn_svc_ai_integration_scope_output5(inputs)
	if (locale === "de") return de_svc_ai_integration_scope_output5(inputs)
	if (locale === "es") return es_svc_ai_integration_scope_output5(inputs)
	if (locale === "fr") return fr_svc_ai_integration_scope_output5(inputs)
	if (locale === "pt") return pt_svc_ai_integration_scope_output5(inputs)
	if (locale === "zh") return zh_svc_ai_integration_scope_output5(inputs)
	if (locale === "tr") return tr_svc_ai_integration_scope_output5(inputs)
	if (locale === "ru") return ru_svc_ai_integration_scope_output5(inputs)
	if (locale === "pl") return pl_svc_ai_integration_scope_output5(inputs)
	return en_svc_ai_integration_scope_output5(inputs)
});
export { svc_ai_integration_scope_output5 as "svc_ai-integration_SCOPE_output" }